import React, { Component } from "react";
import { Menu } from "antd";
import { queryApprovalUserCached } from '../../common/permissionCache';

const SubMenu = Menu.SubMenu;

class SideNav extends Component {
    
    state = {
        isClinicalUser: false,
    }

    componentDidMount() {
        this.queryApprovalUser();
    }

    // 获取标准访视单价菜单权限
    queryApprovalUser = () => {
        queryApprovalUserCached(undefined, res => {
            const { isClinicalUser } = res;
            this.setState({
                isClinicalUser,
            });
        });
    }


    render () {
        const { selectKey } = this.props;
        const { isClinicalUser } = this.state;
        return (
            <aside className="sidebar">
                <Menu
                    openKeys={['sub1']}
                    selectedKeys={[selectKey]}
                    mode="inline"
                >
                    <SubMenu key="sub1" title={<span><i className="icon iconfont">&#xe664;</i><span>我的</span></span>}>
                        <Menu.Item key="information">
                            <a href="#/personal/information">个人信息</a>
                        </Menu.Item>
                        <Menu.Item key="curriculumVitae">
                            <a href="#/personal/curriculumVitae">个人简历</a>
                        </Menu.Item>
                        <Menu.Item key="setting">
                            <a href="#/personal/setting">通知设置</a>
                        </Menu.Item>
                        {
                            isClinicalUser && 
                                <Menu.Item key="file">
                                    <a href="#/personal/file">个人文件夹</a>
                                </Menu.Item>
                        }
                    </SubMenu>
                </Menu>
            </aside>
        );
    }
}

export default SideNav;



// WEBPACK FOOTER //
// ./src/components/personal/SideNav.js